<template>
  <div id="reg">
    <div class="reg-container">
      <!-- 品牌区域 -->
      <div class="brand-section">
        <div class="logo">
          <i class="el-icon-cpu"></i>
        </div>
        <h1 class="brand-title">运维练兵场</h1>
      </div>

      <!-- 注册表单 -->
      <div class="form-section">
        <div class="form-header">
          <h3>用户注册</h3>
        </div>

        <el-form :model="registerForm" class="register-form">
          <div class="input-group">
            <label class="input-label">
              <i class="el-icon-message"></i>
              邮箱地址
            </label>
            <el-input 
              v-model.trim="registerForm.email" 
              placeholder="请输入您的邮箱"
              size="large"
              class="modern-input"
            >
              <template #prefix>
                <i class="el-icon-user"></i>
              </template>
            </el-input>
          </div>

          <div class="input-group">
            <label class="input-label">
              <i class="el-icon-lock"></i>
              密码
            </label>
            <el-input 
              type="password" 
              v-model.trim="registerForm.password" 
              placeholder="请输入密码 (6-20位)"
              size="large"
              class="modern-input"
              show-password
            >
              <template #prefix>
                <i class="el-icon-key"></i>
              </template>
            </el-input>
          </div>

          <div class="input-group">
            <label class="input-label">
              <i class="el-icon-lock"></i>
              确认密码
            </label>
            <el-input 
              type="password" 
              v-model.trim="registerForm.confirmPassword" 
              placeholder="请再次输入密码"
              size="large"
              class="modern-input"
              show-password
            >
              <template #prefix>
                <i class="el-icon-key"></i>
              </template>
            </el-input>
          </div>

          <!-- 提示信息 -->
          <div class="notice-section">
            <p class="info-text">
              <i class="el-icon-info"></i> 单向密码加密，管理员也无法查看您密码。
            </p>
            <el-alert
              title="注册须知: 本网站服务器资源不可用于【运维练习】以外的用途！"
              type="error"
              :closable="false"
              class="warning-alert"
              show-icon
            />
          </div>

          <!-- 注册按钮 -->
          <el-button 
            type="primary" 
            @click="register" 
            class="reg-btn"
            :loading="loading"
            size="large"
          >
            <i class="el-icon-check"></i>
            同意并注册
          </el-button>

          <!-- 登录链接 -->
          <div class="form-links">
            <el-link 
              type="primary" 
              href="/login"
              :underline="false"
            >
              <i class="el-icon-user"></i>
              已有账号，去登录
            </el-link>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  name: "RegPage",
  setup() {
    const registerForm = ref({
      email: "",
      password: "",
      confirmPassword: "",
    });
    const loading = ref(false);

    const register = () => {
      // 验证逻辑
      if (!registerForm.value.email) {
        ElMessage.error({ message: "邮箱地址不可以为空。", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.email.indexOf("@") == -1) {
        ElMessage.error({ message: "邮箱地址缺少必要的at符号。", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.email.indexOf(".") == -1) {
        ElMessage.error({ message: "邮箱地址缺少必要的dot符号。", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.email.length > 40) {
        ElMessage.error({ message: "邮箱地址整体长度超过了40，请输入合法邮箱。", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.email.length < 5) {
        ElMessage.error({ message: "请输入正确的邮箱地址。", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.email === "zhangsan@azlinux.com" || registerForm.value.email === "lisi@azlinux.com") {
        ElMessage.error({ message: "这是示例账户，无法被注册，请使用其他名称。", duration: 5000, offset: 120 });
        return;
      }
      if (registerForm.value.email.startsWith("@")) {
        ElMessage.error({ message: "邮箱不符合规则，不能以at开头。", duration: 3000, offset: 120 });
        return;
      }
      if (!registerForm.value.password) {
        ElMessage.error({ message: "密码不可以为空", duration: 3000, offset: 120 });
        return;
      }
      if (registerForm.value.password.length < 8) {
        ElMessage.error({ message: "密码长度至少8个字符", offset: 120 });
        return;
      }
      if (registerForm.value.password.length > 128) {
        ElMessage.error({ message: "密码长度不可超过128个字符", offset: 120 });
        return;
      }
      if (!/[A-Za-z]/.test(registerForm.value.password) || !/\d/.test(registerForm.value.password)) {
        ElMessage.error({ message: "密码必须同时包含字母和数字", offset: 120 });
        return;
      }
      if (registerForm.value.password !== registerForm.value.confirmPassword) {
        ElMessage.error({ message: "两次输入的密码不一样!", offset: 120 });
        return;
      }

      loading.value = true;

      axios
        .post(`/api/register`, registerForm.value)
        .then((response) => {
          localStorage.setItem("email", "sre-" + response.data.data.email);
          ElMessage({
            message: response.data.message + "，正在进入个人中心...",
            type: "success",
            duration: 2000,
            offset: 120,
          });

          setTimeout(() => {
            window.location.href = "/user-center";
          }, 1000);
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            ElMessage.error({
               message: "该邮箱已被注册，请登录或申诉",
               duration: 3000,
               offset: 120
            });
          } else {
            console.log(error.response);
            ElMessage({
              message: "网络连接失败，稍后重试，或检查网络",
              type: "error",
              duration: 3000,
              offset: 120,
            });
          }
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      registerForm,
      register,
      loading
    };
  },
};
</script>

<style scoped>
#reg {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 注册容器 */
.reg-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 40px;
  width: 460px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 品牌区域 */
.brand-section {
  text-align: center;
  margin-bottom: 24px;
}

.logo {
  width: 60px;
  height: 60px;
  background: #409eff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  color: white;
  font-size: 24px;
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.3);
}

.brand-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e3c72;
  margin: 0;
}

/* 表单区域 */
.form-header {
  text-align: center;
  margin-bottom: 24px;
}

.form-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

/* 输入框组 */
.input-group {
  margin-bottom: 20px;
}

.input-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 8px;
}

.modern-input {
  border-radius: 8px;
}

.modern-input:deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.modern-input:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  border-color: #409eff;
}

/* 提示信息 */
.notice-section {
  margin-bottom: 24px;
}

.info-text {
  font-size: 13px;
  color: #909399;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.warning-alert {
  margin-bottom: 12px;
}

/* 注册按钮 */
.reg-btn {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: #409eff;
  border: none;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
  margin-bottom: 16px;
}

.reg-btn:hover {
  background: #79bbff;
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
}

/* 链接 */
.form-links {
  text-align: center;
}

.form-links .el-link {
  font-size: 14px;
}

/* 响应式 */
@media (max-width: 480px) {
  .reg-container {
    width: 90%;
    padding: 30px 20px;
  }
}
</style>
